import { forwardRef, type ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

const TableHead = forwardRef<HTMLTableCellElement, ComponentProps<'th'>>(
	({ className, ...props }, ref) => (
		<th
			{...props}
			ref={ref}
			className={twMerge(
				'min-h-8 bg-inherit p-3 text-left align-middle text-xs leading-normal tracking-wide text-dm-white md:text-sm',
				className
			)}
		/>
	)
);

TableHead.displayName = 'TableHead';

export default TableHead;
